export const threadMessageId = (id: number | string) => `message-${id}`;

export const parseThreadMessageId = (id: string): number | null => {
  const match = /^message-(\d+)$/.exec(id);
  return match ? Number(match[1]) : null;
};
